import { Column } from './column.model';
import { Filter } from './filter.model';
import { Entity } from '../../entity/entity.model';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';

export class ReportEntity {
    Id: number;
    EntityId: number;
    Alias: string;
    Configuration: string;
    IsMain: boolean;
    Columns: Array<Column>;
    Filters: Array<Filter>;
    Entity: Entity;
    Type: FilterTypeEnum;
}
